export const referenceFields = [
  'customer_id',
  'equipment_ids',
  'order',
  'order_item_ids',
  'opportunity_id',
  'event_id',
  'representative_id',
];
export const referenceModels = {
  customer_id: 'customer',
  equipment_ids: 'equipment',
  order: 'order',
  order_item_ids: 'order_item_ids',
  opportunity_id: 'opportunity',
  event_id: 'event',
  representative_id: 'representative',
};
export const referenceCatalogs = {
  equipment_ids: 'equipamentos',
  order: 'pedidos',
  opportunity_id: 'oportunidades',
  event_id: 'eventos',
  representative_id: 'representantes',
};

export const rulesFor = (schema, form) => {
  const type = schema.types.find(item => item.id === form.type_id);
  if (!type) return { fields: [], required: [] };
  const required = [...type.required_fields];
  const allowed = [...type.required_fields, ...type.optional_fields];
  const forbidden = [];
  (type.conditions || []).forEach(condition => {
    if (
      Object.entries(condition.when).every(
        ([key, value]) => form[key] === value
      )
    ) {
      required.push(...condition.required_fields);
      forbidden.push(...condition.forbidden_fields);
    }
  });
  if (form.customer_is_representative) required.push('representative_id');
  else forbidden.push('representative_id');
  // Activation equipment comes from the selected order items, including software without equipment.
  if (required.includes('order_item_ids')) forbidden.push('equipment_ids');
  return {
    ...type,
    fields: referenceFields.filter(
      key => allowed.includes(key) && !forbidden.includes(key)
    ),
    required,
    scheduled: type.schedule_required,
    allowsRental: allowed.includes('rental_demonstration'),
    allowsRepresentative: allowed.includes('customer_is_representative'),
  };
};

export const emptyForm = (defaults = {}) => ({
  type_id: defaults.type_id ?? null,
  type: defaults.type ?? '',
  priority: defaults.priority ?? '',
  origin: defaults.origin ?? '',
  customer: null,
  equipment: [],
  order: null,
  order_item_ids: [],
  opportunity: null,
  event: null,
  representative: null,
  rental_demonstration: false,
  customer_is_representative: false,
  description: '',
  due_at: '',
  starts_at: '',
  ends_at: '',
  location: '',
  participant_user_ids: [],
});

export const invalidFields = (schema, form) => {
  const rules = rulesFor(schema, form);
  if (!rules.id) return { type_id: 'GG_SUPPORT.REQUIRED' };
  const fields = {};
  if (!form.description.trim()) fields.description = 'GG_SUPPORT.REQUIRED';
  rules.required
    .filter(key => key !== 'schedule')
    .forEach(key => {
      const value = form[referenceModels[key]];
      if (!value || (Array.isArray(value) && !value.length))
        fields[key] = 'GG_SUPPORT.REQUIRED';
    });
  if (rules.scheduled) {
    ['starts_at', 'ends_at'].forEach(key => {
      if (!form[key]) fields[key] = 'GG_SUPPORT.REQUIRED';
    });
    if (
      form.starts_at &&
      form.ends_at &&
      new Date(form.ends_at) <= new Date(form.starts_at)
    )
      fields.ends_at = 'GG_SUPPORT.ERRORS.SCHEDULE_INVALID';
  }
  return fields;
};
const isoDate = value =>
  value ? new Date(value).toISOString().replace('.000Z', 'Z') : null;
export const serializeForm = (form, schema) => {
  const rules = rulesFor(schema, form);
  const payload = {
    type_id: form.type_id,
    priority: form.priority,
    origin: form.origin,
    description: form.description,
    due_at: isoDate(form.due_at),
    rental_demonstration: form.rental_demonstration,
    customer_is_representative: form.customer_is_representative,
  };
  rules.fields.forEach(key => {
    const value = form[referenceModels[key]];
    if (key === 'equipment_ids') payload[key] = value.map(item => item.id);
    else if (key === 'order_item_ids') payload[key] = value;
    else if (key === 'order')
      payload[key] = value ? { id: value.id, kind: value.kind } : null;
    else payload[key] = value?.id ?? null;
  });
  if (rules.scheduled)
    payload.schedule = {
      starts_at: isoDate(form.starts_at),
      ends_at: isoDate(form.ends_at),
      location: form.location,
      participant_user_ids: form.participant_user_ids,
    };
  return payload;
};
const localDate = value =>
  value
    ? new Date(
        new Date(value).getTime() - new Date(value).getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 16)
    : '';
export const restoreForm = draft => {
  const fields = draft.fields;
  const refs = draft.references;
  return {
    ...emptyForm(),
    ...fields,
    customer: refs.customer || null,
    equipment: refs.equipment || [],
    order: refs.order || null,
    opportunity: refs.opportunity_id || null,
    event: refs.event_id || null,
    representative: refs.representative_id || null,
    due_at: localDate(fields.due_at),
    starts_at: localDate(fields.schedule?.starts_at),
    ends_at: localDate(fields.schedule?.ends_at),
    location: fields.schedule?.location || '',
    participant_user_ids: fields.schedule?.participant_user_ids || [],
  };
};
